import React, { PropsWithChildren } from 'react';

import './index.scss';

export default function QueryCard({ children }: PropsWithChildren) {
  return <div className="query-card">{children}</div>;
}
